var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.25 0.75L5.5 6L0.25 11.25V0.75Z","fill":"currentColor"}));
}

SVGIcon.defaultProps = {"width":"6","height":"12","viewBox":"0 0 6 12","fill":"none"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
